import { TAddress } from "@type/api/types";

type GetAddressPreviewProps = {
  addresses?: TAddress[];
  ignoreKeys?: Array<Partial<keyof TAddress>>;
  postalCodeMark?: string;
  isResidence?: boolean;
};

export const getAddressPreview = ({
  addresses,
  ignoreKeys,
  postalCodeMark,
  isResidence,
}: GetAddressPreviewProps) => {
  if (!addresses?.length) return "";
  let activeAddress = isResidence ? undefined : addresses[0];

  const defaultAddress = addresses.find((address) =>
    isResidence ? address.isResidence : address.isDefault
  );

  if (defaultAddress) {
    activeAddress = defaultAddress;
  }

  if (!activeAddress) return "";

  const keys: Array<Partial<keyof TAddress>> = [
    "prefecture",
    "city",
    "addressLine1",
    "addressLine2",
  ];

  let strAddress = "";

  if (activeAddress?.["postalCode"]) {
    strAddress = `${postalCodeMark || ""}${activeAddress?.["postalCode"]}`;
  }

  for (const key of keys) {
    if (!activeAddress?.[key] || ignoreKeys?.includes(key)) continue;

    if (!strAddress) {
      strAddress = activeAddress[key] as any;
    } else {
      strAddress += ` ${activeAddress[key]}`;
    }
  }

  return strAddress;
};
